// extracted by mini-css-extract-plugin
export default {"wrapper":"sales_wrapper__OsnRZ","header":"sales_header__uwnsI"};